import { paths } from '@/api/openapi/schema';

export type AudioAssessmentResult = NonNullable<paths['/assessments/audios']['post']['responses']['200']['content']['application/json']>['result'];

// version 2 of audio assessment result, with adjusted scores and detailed focus metrics
export function isAdjustedAudioAssessmentResult(value: unknown): value is AudioAssessmentResult {
    if (typeof value !== 'object' || value === null) return false;
    const obj = value as Record<string, unknown>;
    if (typeof obj['refText'] !== 'string') return false;
    if (!Array.isArray(obj['characters'])) return false;
    if (typeof obj['level'] !== 'number') return false;
    if (typeof obj['focusMetrics'] !== 'object' || obj['focusMetrics'] === null) return false;
    const fm = obj['focusMetrics'] as Record<string, unknown>;

    const hasFocusMetrics =
        typeof fm['pronunciationFocus'] === 'boolean' &&
        typeof fm['initialFocus'] === 'boolean' &&
        typeof fm['vowelFocus'] === 'boolean' &&
        typeof fm['toneFocus'] === 'boolean' &&
        typeof fm['fluencyFocus'] === 'boolean';

    if (!hasFocusMetrics) return false;

    if (typeof obj['calculatedScore'] !== 'object' || obj['calculatedScore'] === null) return false;
    const cs = obj['calculatedScore'] as Record<string, unknown>;
    return (
        typeof cs['overall'] === 'number' &&
        typeof cs['pronunciation'] === 'number' &&
        typeof cs['tone'] === 'number' &&
        typeof cs['initial'] === 'number' &&
        typeof cs['vowel'] === 'number' &&
        typeof cs['fluency'] === 'number'
    );
}
